import React from 'react'
import Main from '../../Layout/Main'
import Tittle from '../../Components/nominees/Tittle'
import SideBar from '../../Components/nominees/SideBar'
import Subscribe from '../../Components/nominees/Subscribe'

const Nominees = () => {
  return (
    <Main>
<Tittle/>
<SideBar/>
<Subscribe/>

    </Main>
  )
}

export default Nominees